import { convertConfig } from './helpers/configuration-transformation';
import loadFiles from './helpers/file-loader';
import getAppContext from './helpers/get-app-context';
import log from './helpers/log-helper';
import setDefaultValues from './helpers/set-default-values';
import { installTrackingAgent, setCustomAttributesForNewRelic } from './helpers/usage-tracking-helper';

const newRelicUsageTracking = {
    installTrackingAgent,
    setCustomAttributes: setCustomAttributesForNewRelic,
};

export {
    convertConfig,
    getAppContext,
    loadFiles,
    log,
    newRelicUsageTracking,
    setDefaultValues,
};



// WEBPACK FOOTER //
// ../loader-base/src/helpers.js